// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-scroll {
  overflow-x: auto;
  position: relative;
}
.x-scroll table {
  margin-bottom: 2em;
}

.table-title {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.table-title b {
  margin-left: 6px;
  grid-column: span 3;
  align-self: center;
}
.table-title button {
  grid-column: span 1;
}

.mat-mdc-table {
  width: 100%;
  border-collapse: separate;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-header-cell {
  font-weight: bold;
  padding: 0 1em 0 1em;
}

.mat-mdc-cell {
  padding: 0 1em 0 1em;
}

.button-spacer button {
  margin-right: 10px;
}

.button-spacer button:last-child {
  margin-right: 0px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZlaGljbGUtc3VicmVjb3Jkcy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGdCQUFBO0VBQ0Esa0JBQUE7QUFDRjtBQUNFO0VBQ0Usa0JBQUE7QUFDSjs7QUFHQTtFQUNFLGFBQUE7RUFDQSxxQ0FBQTtBQUFGO0FBQ0U7RUFDRSxnQkFBQTtFQUNBLG1CQUFBO0VBQ0Esa0JBQUE7QUFDSjtBQUNFO0VBQ0UsbUJBQUE7QUFDSjs7QUFHQTtFQUNFLFdBQUE7RUFDQSx5QkFBQTtBQUFGOztBQUdBOztFQUVFLFlBQUE7RUFDQSxtQkFBQTtBQUFGOztBQUdBO0VBQ0UsaUJBQUE7RUFDQSxvQkFBQTtBQUFGOztBQUdBO0VBQ0Usb0JBQUE7QUFBRjs7QUFHQTtFQUNFLGtCQUFBO0FBQUY7O0FBR0E7RUFDRSxpQkFBQTtBQUFGIiwiZmlsZSI6InZlaGljbGUtc3VicmVjb3Jkcy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi54LXNjcm9sbCB7XG4gIG92ZXJmbG93LXg6IGF1dG87XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICB0YWJsZSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMmVtO1xuICB9XG59XG5cbi50YWJsZS10aXRsZSB7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KDQsIDFmcik7XG4gIGIge1xuICAgIG1hcmdpbi1sZWZ0OiA2cHg7XG4gICAgZ3JpZC1jb2x1bW46IHNwYW4gMztcbiAgICBhbGlnbi1zZWxmOiBjZW50ZXI7XG4gIH1cbiAgYnV0dG9uIHtcbiAgICBncmlkLWNvbHVtbjogc3BhbiAxO1xuICB9XG59XG5cbi5tYXQtbWRjLXRhYmxlIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGJvcmRlci1jb2xsYXBzZTogc2VwYXJhdGU7XG59XG5cbi5tYXQtbWRjLXJvdyxcbi5tYXQtbWRjLWhlYWRlci1yb3cge1xuICBoZWlnaHQ6IDM1cHg7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG59XG5cbi5tYXQtbWRjLWhlYWRlci1jZWxsIHtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIHBhZGRpbmc6IDAgMWVtIDAgMWVtO1xufVxuXG4ubWF0LW1kYy1jZWxsIHtcbiAgcGFkZGluZzogMCAxZW0gMCAxZW07XG59XG5cbi5idXR0b24tc3BhY2VyIGJ1dHRvbiB7XG4gIG1hcmdpbi1yaWdodDogMTBweDtcbn1cblxuLmJ1dHRvbi1zcGFjZXIgYnV0dG9uOmxhc3QtY2hpbGQge1xuICBtYXJnaW4tcmlnaHQ6IDBweDtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/components/vehicle-subrecords/vehicle-subrecords.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,aAAA;EACA,qCAAA;AAAF;AACE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,WAAA;EACA,yBAAA;AAAF;;AAGA;;EAEE,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;AACA,wkDAAwkD","sourcesContent":[".x-scroll {\n  overflow-x: auto;\n  position: relative;\n\n  table {\n    margin-bottom: 2em;\n  }\n}\n\n.table-title {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  b {\n    margin-left: 6px;\n    grid-column: span 3;\n    align-self: center;\n  }\n  button {\n    grid-column: span 1;\n  }\n}\n\n.mat-mdc-table {\n  width: 100%;\n  border-collapse: separate;\n}\n\n.mat-mdc-row,\n.mat-mdc-header-row {\n  height: 35px;\n  white-space: nowrap;\n}\n\n.mat-mdc-header-cell {\n  font-weight: bold;\n  padding: 0 1em 0 1em;\n}\n\n.mat-mdc-cell {\n  padding: 0 1em 0 1em;\n}\n\n.button-spacer button {\n  margin-right: 10px;\n}\n\n.button-spacer button:last-child {\n  margin-right: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
